import React from 'react';
import PropTypes from 'prop-types';
import '../containers/Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons';
import { faVideo } from '@fortawesome/free-solid-svg-icons';

/**
 * Card for Por Demanda (virtual/on-demand events)
 * @param {object} props
 * @param {object} props.show - Show/event data
 * @param {function} props.renderGenreIcon - Function to render genre icon
 */
export function OnDemandEventCard({ show, renderGenreIcon }) {
  return (
    <div className="ondemand-card">
      <div className="ondemand-card__image-wrapper">
        <img className="ondemand-card__image" src={show.main_image} alt={show.fullname} />
        <div className="ondemand-card__play-icon">
          <FontAwesomeIcon icon={faPlayCircle} />
        </div>
        <div className="ondemand-card__gradient" />
      </div>
      <div className="ondemand-card__content">
        <div className="ondemand-card__row ondemand-card__row--badges">
          <span className="ondemand-card__badge ondemand-card__badge--virtual">VIRTUAL</span>
        </div>
        <div className="ondemand-card__row ondemand-card__row--title" style={{flex: 1, alignItems: 'flex-start'}}>
          <div className="ondemand-card__title">{show.fullname}</div>
        </div>
        <div className="ondemand-card__row ondemand-card__row--footer">
          <div className="ondemand-card__footer">
            <div className="ondemand-card__ondemand">
              <FontAwesomeIcon icon={faVideo} style={{ marginRight: '4px' }} /> Por demanda
            </div>
            <div className="ondemand-card__genre">{renderGenreIcon(show)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

OnDemandEventCard.propTypes = {
  show: PropTypes.object.isRequired,
  renderGenreIcon: PropTypes.func.isRequired,
}; 